module.exports = __webpack_public_path__ + "static/media/boomea-white-logo.8d89a3ab.svg";